import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import { message } from 'ant-design-vue'
import config from './config'
import Vue from 'vue'
const root = {
  state:{
    ...config.state,
    visitorInfo: { // 当前访客 链接上带的信息
      tenantId: '',
      visitorId: '',// 访客id 1
      visitorName: '',// 访客名称
      typeId: '', // 大渠道
      typeName: '',
      channelCode: '', // 小渠道
      channelName: '',
      groupId: '',
      groupName: ''
    },
    currentGroup: { // 当前渠道技能组
      groupId: '', // 技能组id
      groupName: '', // 渠道名称
      visitStatus: '3', // 访客在该技能组的状态
      unreadMsgCount: '', // 未读消息数量
    },
    channelGroupVoList: [], // 所有技能组
    skillGroupAll: [],
    visitorBasicInfo: {}, // 访客基本信息
    commonUseInfo : {},
    accessLog: { // 来访记录
      features: {}
    },
    history:  { // 历史会话
      services: []
    },
    service: { // 会话信息
      channel: {} // 渠道信息
    }, // 会话详细信息
    isOfflineMessage: false, // 判断是否是离线消息
    isConnection: false, // 判断socket是否连接
    queueTips: '', // 排队提示
    queueStatus: false,
    bOnlineVisitor: false, // 访客是否在线
    noticeEvaluate: {},
    isCusServiceInput: {}, // 正在输入中
    visitorStatus: false,
    isEndChat: false,
    channelGroupVoListItem: [],
    directConnect: false,
    referenceMessageObj: {} // 被引用的消息
  },
  getters: {
    serviceId (state) { // 当前会话id
      return state.service.serviceId
    },
    serviceTime (state) {
      return state.service.beginTime
    },
    historyServices (state) { // 历史会话集合
      let newServices = state.history.services || []
      newServices.sort((a, b) => {
        let aTime = +a.beginTime.replace(/-/g, '').replace(/ /g, '').replace(/:/g, '')
        let bTime = +b.beginTime.replace(/-/g, '').replace(/ /g, '').replace(/:/g, '')
        return bTime - aTime
      })
      return newServices
    },
    historyServicesIds (state) { // 历史会话集合
      let newServices = state.history.services || []
      return newServices.map((item) => {
        return item.serviceId
      })
    },
    agentId (state) { // 与该访客建立会话的客服id
      return state.service.agentId
    },
    agentName (state) { // 与该访客建立会话的客服name
      return state.service.agentName
    },
    agentJobNum (state) {
      return state.service.agentJobNum
    },
    groupId (state) {
      return state.currentGroup.groupId
    },
    groupName (state) {
      return state.currentGroup.groupName
    },
    groupStatus (state) {
      console.log(state.currentGroup.visitStatus, 'visitStatus值变化');
      return state.currentGroup.visitStatus
    },
    h5GroupVoList (state) {
      return state.channelGroupVoList.map((ev, i) => {
        return {
          text: ev.groupName,
          value: i
        }
      })
    },
    noticeEvaluateInfo (state) {
      let info = ''
      Object.values(state.noticeEvaluate).forEach((ev) => {
        if (ev) {
          info = info + `${ev.groupName}客服邀请你评价本次服务，请前往${ev.groupName}评价本次服务,`
        }
      })
      if (info) {
        info = info.substring(0, info.length - 1)
      }
      return info
    },
    allGroupUnreadyNum (state) {
      let allNum = 0
      state.channelGroupVoList.forEach((item) => {
        if (!item.unreadMsgCount) {
          item.unreadMsgCount = 0
        }
        allNum += item.unreadMsgCount
      })
      return allNum
    },
    ...config.getters
  },
  mutations:{
    ...config.mutations,
    set_isEndChat (state, value) {
      state.isEndChat = value
    },
    updateDirectConnect (state, value) {
      state.directConnect = value
    },
    setVisitorInfo (state, msg) {
      // Object.assign(state.visitorInfo,msg);
      state.visitorInfo = {...state.visitorInfo, ...msg}
    },
    set_visitorBasicInfo (state, v) {
      state.visitorBasicInfo = {...state.visitorBasicInfo, ...v}
    },
    set_currentGroup (state, v) { // 设置当前技能组
      console.log(v, '当前技能组')
      state.currentGroup = {...state.currentGroup, ...v}
    },
    set_service (state, v) {
      state.service = v
    },
    set_history (state, v) {
      state.history = v
    },
    set_accessLog (state, v) {
      state.accessLog = v
    },
    set_bOnlineVisitor (state, msg) {
      state.bOnlineVisitor = msg
    },
    set_channelGroupVoList (state, v) {
      state.channelGroupVoList = v
    },
    updateGroupListById (state, v) { // 更改技能组列表信息
      state.channelGroupVoList.forEach((item) => {
        if (v.groupId === item.groupId) {
          item.visitStatus = v.status
          if (v.status === '1') {
            item.service = v.service
            item.history = v.history
            item.accessLog = v.accessLog
          }
        }
      })
    },
    onlyUpdateGroupStatus (state, v) { // 更改技能组状态
      if (v.groupId === state.currentGroup.groupId) {
        state.currentGroup.visitStatus = v.status
      }
      state.channelGroupVoList.forEach((item) => {
        if (v.groupId === item.groupId) {
          item.visitStatus = v.status
        }
      })
    },
    updateGroupUnreadyNum (state, v) {
      state.channelGroupVoList.forEach((item) => {
        if (v === item.groupId) {
          if (!item.unreadMsgCount) {
            item.unreadMsgCount = 0
          }
          item.unreadMsgCount++
        }
      })
    },
    clearGroupUnreadyNum(state, v) { // 清空该技能组下的未读数量
      state.channelGroupVoList.forEach((item) => {
        if (v === item.groupId) {
          item.unreadMsgCount = 0
        }
      })
    },
    setOfflineMessage (state, msg) {
      state.isOfflineMessage = msg
    },
    setCanSelectSkill (state, msg) {
      state.isCanSelectSkill = msg
    },
    setConnection (state, msg) {
      state.isConnection = msg
    },
    set_accessDetail (state, msg) {
      state.accessDetail = msg
    },
    set_skillGroupAll (state, msg) {
      state.skillGroupAll = msg
    },
    set_queueTips (state, msg) {
      state.queueTips = msg
    },
    set_queueStatus (state, msg) {
      state.queueStatus = msg
    },
    set_noticeEvaluate (state, msg) {
      Vue.set(state.noticeEvaluate, msg.serviceId, msg.content)
    },
    deleteKey_noticeEvaluate (state, serviceId) {
      Vue.set(state.noticeEvaluate, serviceId, null)
      delete state.noticeEvaluate[serviceId]
    },
    set_isCusServiceInput (state, msg) {
      Vue.set(state.isCusServiceInput, msg.groupId, msg.content)
    },
    set_visitorStatus (state, status) {
      state.visitorStatus = status
    },
    set_channelGroupVoListItem (state, v) {
      state.channelGroupVoListItem = v
    },
    set_referenceMessage (state, v) {
      state.referenceMessageObj = v
    }
  },
  actions: {
    ...config.actions,
    get_skillGroupAll ({commit,state}) {
      return new Promise((resolve, reject) => {
        let params = {params:{tenantId: state.visitorInfo.tenantId, sourceId: state.visitorInfo.sourceId}}
        ajax.get(apis.chat.queryGroupByChannel, params).then((res) => {
          if (res.success) {
            if ( res.data.length == 1) {
              commit('setVisitorInfo', {skillId: res.data[0].skillId})
              resolve(true)
            } else {
              commit('set_skillGroupAll', res.data)
            }
          }
        })
      })
    },
    get_queue ({commit,state}, that) {
      let params = {params:{tenantId: state.visitorInfo.tenantId, skillId: state.visitorInfo.groupId, visitorId: state.visitorInfo.visitorId}}
      ajax.get(apis.chat.queueNum, params).then((res) => {
        if (res.success) {
          commit('set_queueTips', res.data.queueTips)
        }
      })
    }
  }
}

export default root
